<script>

  export default {
    props: {
      item: {
        type: null,
        required: true,
      },
    },
  }
</script>

<template>
  <div class="tw-flex tw-flex-col lg:tw-flex-row tw-justify-between">
    <div class="tw-w-full lg:tw-w-3/5">
      <ul class="default-list">
        <li class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Model Number</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">
            {{ item.code }}
          </span>
        </li>
        <li class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Product Name</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">
            {{ item.name }}
          </span>
        </li>
        <li class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Status</span>
          <span class="w-w-full tw-pl-12 tw-pb-2">
            <BaseStatusChip :status="item.status" />
          </span>
        </li>
        <li class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Description</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">
            {{ item.description }}
          </span>
        </li>
        <li class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Brand</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">
            {{ item.brand.name }}
          </span>
        </li>
        <li v-if="item.category && item.category.parent && item.category.parent.parent" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Category</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">
            {{ item.category.parent.parent.name }}
          </span>
        </li>
        <li v-if="item.category && item.category.parent" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Secondary Category</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">
            {{ item.category.parent.name }}
          </span>
        </li>
        <BaseMultipleCategoryItem v-if="item.category && item.category.parent && item.category.parent.parent" :category="item.category.parent.parent" tailwind />
        <BaseMultipleCategoryItem v-if="item.category && item.category.parent" :category="item.category.parent" tailwind />
        <BaseMultipleCategoryItem :category="item.category" tailwind />
        <li v-if="item.cost_price" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Cost Price</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">${{ item.cost_price }}</span>
        </li>
        <li v-if="item.rrp" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">RRP</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">${{ item.rrp }}</span>
        </li>
        <li v-if="item.weight" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Weight</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">{{ item.weight }} kg</span>
        </li>
        <li v-if="item.width" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Width</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">{{ item.width }} mm</span>
        </li>
        <li v-if="item.height" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Height</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">{{ item.height }} mm</span>
        </li>
        <li v-if="item.length" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Length</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">{{ item.length }} mm</span>
        </li>
        <li v-if="item.warranty_parts" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Warranty Parts</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">{{ item.warranty_parts }}</span>
        </li>
        <li v-if="item.warranty_labour" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Warranty Labour</span>
          <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2">{{ item.warranty_labour }}</span>
        </li>
        <li v-if="item.attachments.length" class="tw-flex tw-flex-col">
          <span class="tw-text-black/75 tw-w-full">Attachments</span>
          <ul class="tw-pl-4">
            <li v-for="attachment in item.attachments" :key="attachment.id" class="tw-list-disc">
              <span class="tw-font-semibold  w-w-full tw-pl-12 tw-pb-2"><a :href="attachment.url" target="_blank">{{ attachment.name }}</a></span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div
      class="
      tw-w-full lg:tw-w-2/5
      tw-inline-flex tw-items-center tw-justify-center
      ">
      <BaseDetailImage :images="item.images" />
    </div>
  </div>
</template>
